import { TailSpin } from "react-loader-spinner"

export interface LoaderProps {
    width ?: number 
    height ?: number
}

export const Loader = (props: LoaderProps) => {
    return(
        <TailSpin
            visible={true}
            height={props.height ? props.height : 50}
            width={props.width ? props.width : 50}
            color="#282828"
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
    )
}